import { render, staticRenderFns } from "./driver.vue?vue&type=template&id=048067d8&scoped=true&"
import script from "./driver.vue?vue&type=script&lang=js&"
export * from "./driver.vue?vue&type=script&lang=js&"
import style0 from "./driver.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./driver.vue?vue&type=style&index=1&id=048067d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048067d8",
  null
  
)

export default component.exports